module.exports = __webpack_public_path__ + "static/hooks-dddd23b10a6989e54fe572fa2862ba60.png";